const defaultPageSizes: number[] = [5, 10, 15, 20, 25]
const defaultPageSize: number = 10

export { defaultPageSizes, defaultPageSize }
